import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel } from '../../models';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AllocationViewCallToArrivalSecurityActionService {
  constructor(private http: WrapperHttpService) {}

  callToArrivalSecurityCheck(actionIdentifier: AllocationViewActionIdentifierModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.CallToArrivalSecurity}`;

    return this.http.withLoading().post<void>(url, actionIdentifier);
  }
}
